import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, {
    app: "",
    padless: "",
    dark: "",
    height: "30px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "text-center text-caption pa-0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(new Date().getFullYear()) + " — WUD (version " + _toDisplayString(_ctx.version) + ") ", 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}